module.exports = __webpack_public_path__ + "static/media/download-signature.5b5dcfba.svg";